import clsx from 'clsx';

export default function Spinner({ fullPage, className, label = 'Loading' }) {
  const spinner = (
    <div
      role="status"
      aria-label={label}
      className={clsx(
        // Static full ring instead of a spin for prefers-reduced-motion users.
        'motion-safe:animate-spin rounded-full border-2 border-slate-200 border-t-brand-600 motion-reduce:border-brand-600',
        className || 'h-8 w-8'
      )}
    />
  );

  if (fullPage) {
    return (
      <div className="flex items-center justify-center min-h-screen surface-base">
        <div className="flex flex-col items-center gap-4">
          <div className="h-14 w-14 rounded-2xl bg-slate-900 shadow-sm flex items-center justify-center">
            <img src="/brand/mark-transparent.png" alt="" aria-hidden="true" className="h-8 w-8" loading="lazy" />
          </div>
          {spinner}
        </div>
      </div>
    );
  }
  return spinner;
}
